import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ResidenceOptions = "house" | "flat";

export interface ResidenceState {
  residenceType: ResidenceOptions | null;
  occupantCount: number;
}

const initialState: ResidenceState = {
  residenceType: null,
  occupantCount: 1,
};

const residenceSlice = createSlice({
  name: "residence",
  initialState,
  reducers: {
    setResidenceType(state, action: PayloadAction<ResidenceOptions | null>) {
      state.residenceType = action.payload;
    },
    setOccupantCount(state, action: PayloadAction<number>) {
      state.occupantCount = action.payload;
    },
    setResidenceState(state, action: PayloadAction<ResidenceState>) {
      state = action.payload;
    },
  },
});

export const { setResidenceType, setOccupantCount, setResidenceState } =
  residenceSlice.actions;

export default residenceSlice.reducer;
